var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m10 8 4 4-4 4","stroke":"#9ca3af","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

Chevron.defaultProps = {"fill":"none","height":"24","width":"24"};

module.exports = Chevron;

Chevron.default = Chevron;
